/**Packages */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

/* Helpers */
import { manageAssistant } from '../../../helpers/assistant';
import { trackCustomPageview } from '../../../helpers/GTMEvents';
import { getPixelData, getIfInternalThemeIsOneMinuteSimulator } from '../../../helpers/utils';
/* Redux */
import { useSelector, useDispatch } from 'react-redux';
import { setModalThunk, setSkipSimulationThunk } from '../../../redux/actions/index';

/* Components */
import { Header } from '../../shared/Header';
import { Overlay } from '../../shared/Overlay';
import { Modal } from '../../shared/Modal';
import { MainContentWrapper } from '../../shared/MainContentWrapper';
import { PageHeading } from '../../shared/PageHeading';
import { SimulationRecap } from '../../shared/SimulationRecap';
import { BizmaticaHiddenForm } from '../../shared/BizmaticaHiddenForm';
import { QuidHiddenForm } from '../../shared/QuidHiddenForm';
import { RecapButtons } from '../../shared/RecapButtons';
import { Footer } from '../../shared/Footer';
import { ScrollArrows } from '../../shared/ScrollArrows';

export const Recap = () => {
  const history = useHistory();
  const useSubmit = history?.location?.state?.returnPage 
                  && history?.location?.state?.returnPage.includes('1-minuto')  ? 
                    true 
                  : 
                    false;
  const returnPage = history?.location?.state?.returnPage ? 
                    history?.location?.state?.returnPage 
                    : 
                    'simulatore-commerciale.html';

  const internalTheme = useSelector(state => state.internalTheme);
  const { purpose } = useSelector(state => state.currentSimulation);
  const { icon, text: purposeText } = purpose;
  
  const isCompassOneMinute = getIfInternalThemeIsOneMinuteSimulator(internalTheme);

  const dispatch = useDispatch();
  const setModal = (modal, options) => dispatch(setModalThunk(modal, options));
  const setSkipSimulation = (skipSimulation) => dispatch(setSkipSimulationThunk(skipSimulation));

  const origin = window.location.origin;

  const getForm = () => {
    return !isCompassOneMinute ?
        (
          <BizmaticaHiddenForm
            useSubmit={useSubmit} 
            returnUrl={`${origin}/simulatore/${returnPage}?SC_RICALCOLO=S`}
          >
            <RecapButtons 
              returnPage={returnPage}
            />
          </BizmaticaHiddenForm>
        )
        :
        (
          <QuidHiddenForm
            useSubmit={useSubmit} 
            returnUrl={`${origin}/simulatore/${returnPage}?SC_RICALCOLO=S`}
          >
            <RecapButtons 
              returnPage={returnPage}
            />
          </QuidHiddenForm>
          
        );
  }

  useEffect(function() {
    getPixelData('/risultato-profilo-web.html');

    window.scrollTo(0, 0);

    setSkipSimulation(false);

    trackCustomPageview();

    manageAssistant(false);
  }, []);

  return (
    <>
      <Overlay 
        modalTarget="moreInfo"
        clickEvent={
          function() {
            setModal('moreInfo', {
              isVisible: false,
            })
          }
        }
      >
        <Modal
          content={
            {
              text: ["I valori dei tassi (TAN e TAEG) rimarranno espressi come intervallo tra minimo e massimo, finchè non avremo preso in carico e valutato la tua richiesta.", <br key="1" />, "Per personalizzare la tua richiesta di prestito ti chiediamo quindi di fornirci maggiori informazioni."]
            }
          }
          button={
            {
              text: "Ok, ho capito",
              clickEvent: function() {
                setModal('moreInfo', {
                  isVisible: false,
                })
              },
            }
          }
        />
      </Overlay>
      <Header logo={
        {
          image: './images/logo_compass_negative.png',
          alt: 'Logo compass negative',
          redirect: `/simulatore${returnPage}`,
        }
      } />
      <MainContentWrapper>
        <PageHeading title="Il tuo prestito" purpose={{icon, text: purposeText}} />
        <div className="loan-middle-rpp">
          <div className="loan-main-details-rpp">
            <SimulationRecap />
            <div className="loan-main-btn-rpp">
              {getForm()}
              <div className="clearfix"></div>
            </div>
            {
              !isCompassOneMinute 
              &&
              (
                <div className="loan-bottom-text-rpp">
                  <p>I valori di TAN e TAEG rimarranno espressi in range finché non avremo preso in carico e valutato la tua richiesta</p>
                </div>
              ) 
            }
          </div>
        </div>
      </MainContentWrapper>
      <Footer useBold={true} />
      <ScrollArrows />
    </>
  );
}

export default Recap;
